<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-top-navbar-wrapper" :class="classObj">

      <vs-navbar class=" navbar-custom navbar-skelton" :color="navbarColor2" :class="textColor2">
          <!-- <vs-navbar class="vx-navbar vs-navbar navbar-custom navbar-skelton" style="background-color:#f8f8f8;"> -->

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <!-- <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" /> -->
        <!-- <feather-icon class="sm:flex hidden xl:hidden cursor-pointer p-4" icon="MenuIcon" @click.stop="showSidebar" /> -->
        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->


          <!-- &nbsp; -->
          <div v-if="windowWidth >= 992">
            <router-link tag="div" class="vx-logo cursor-pointer flex items-center" to="/apps/space/">
              <img src="@/assets/images/intro/intro_logo.png" alt="FilledU"/>
            </router-link>
          </div>

          <div class="lg:w-1/6 md:w-1/4 sm:w-1/3 bg-white rounded">
            <!-- <v-select v-model="selected" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
            <v-select v-model="selected" :options="workspaceList"/>
          </div>
          <vs-spacer />

        <!-- <search-bar /> -->

        &nbsp;<i18n />
        <!-- <cart-drop-down /> -->
        &nbsp;&nbsp; <notification-drop-down />
        &nbsp; <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
// import Bookmarks            from "./components/Bookmarks.vue"
import I18n                 from "./components/I18n.vue"
import SearchBar            from "./components/SearchBar.vue"
import SpaceList        from "./components/SpaceList.vue"
// import CartDropDown         from "./components/CartDropDown.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"
import vSelect from 'vue-select'

export default {
  name: "the-task-top-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
    workspaceList:{
      type: Array,
      required: true
    },
    seleleteItem:{
      type:Object,
      required: true
    }
  },
  watch: {
    seleleteItem(val) {
      this.selected = val
    },
    selected(val) {
      var projectList = []
      for (var index in this.$store.state.project.workspaceProjects) {
        if(this.$store.state.project.workspaceProjects[index].workspace_id == val.id) {
          projectList.push(this.$store.state.project.workspaceProjects[index])
        }
      }
      this.$store.commit('project/SET_SELECT_WORKSPACE', val)
      this.$store.commit('project/SET_PROJECT_LIST', projectList)
      this.$emit('selectWorkspace')
    }
    // seleleteItem(value) {
    //   var projectList = []
    //   for (var index in this.$store.state.project.workspaceProjects) {
    //     if(this.$store.state.project.workspaceProjects[index].workspace_id == value.id) {
    //       projectList.push({id:this.$store.state.project.workspaceProjects[index].id, label:this.$store.state.project.workspaceProjects[index].title})
    //     }
    //   }
    //   this.$store.commit('project/SET_SELECT_WORKSPACE', value)
    //   this.$store.commit('project/SET_PROJECT_LIST', projectList)
    // },
  },
  data() {
    return {
      selected:{id: 1, label: '없음'},
      navbarColor2:'dark',
      textColor2:'#ffffff'
    }
  },
  components: {
    // Bookmarks,
    I18n,
    SearchBar,
    SpaceList,
    // CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
    'v-select': vSelect,
  },
  computed: {
    // navbarColorLocal() {
    //   return "dark"
    // },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    // textColor2() {
    //   return "#ffffff"
    // },
    windowWidth() {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    },
  },
  created() {
    // this.selected = this.seleleteItem
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    }
  }
}
</script>
